import { useState, useCallback } from 'react';

// Services

import ListsService from '../services/lists.service';

export default function InsertSpouseAndRepresentativePepForRevision() {
    const [insertSpouseRepresentativePepForRevisionIsLoading, setInsertSpouseRepresentativePepForRevisionIsLoading] = useState(false);
    const [insertSpouseRepresentativePepForRevisionError, setInsertSpouseRepresentativePepForRevisionError] = useState(null);
    const [insertSpouseRepresentativePepForRevision, setInsertSpouseRepresentativePepForRevision] = useState(null);

    // Handle Insert Spouse And Representative For Revision

    const handleInsertSpouseRepresentativePepForRevision = useCallback(async (values, list, spouseOnList, representativeOnlist, peopOnlist, state, exsting, misCode) => {
        setInsertSpouseRepresentativePepForRevisionIsLoading(true);
        setInsertSpouseRepresentativePepForRevisionError(null);

        try {
            const clientEmail = localStorage.getItem("clientEmail");

            let data = {
                full_name: values?.cliente?.nombre + ' ' +  values?.cliente?.primerApellido + ' ' + values?.cliente?.segundoApellido,
                email: clientEmail ? clientEmail : state?.userPartialData?.email,
                document: values?.cliente?.tipoDocumento !== 'P' ? values?.cliente?.tipoDocumento + values?.cliente?.cedulaRif : values?.cliente?.tipoDocumento + values?.cliente?.pasaporte,
                type: exsting ? "existente" : "nuevo",
                codigo_mis: misCode ? misCode : null,
            }
    
            if (spouseOnList) {
                data.conyuge = {
                    full_name: values?.conyuge?.nombre + " " + values?.conyuge?.primerApellido + " " + values?.conyuge?.segundoApellido,
                    document: values?.conyuge?.tipoDocumento !== 'P' ? values?.conyuge?.tipoDocumento + values?.conyuge?.cedulaRif : values?.conyuge?.tipoDocumento + values?.conyuge?.pasaporte,
                    font: list
                };
            }
    
            if (representativeOnlist) {
                data.apoderado = {
                    full_name: values?.apoderado?.nombre + " " + values?.apoderado?.primerApellido + " " + values?.apoderado?.segundoApellido,
                    document: values?.apoderado?.tipoDocumento !== 'P' ? values?.apoderado?.tipoDocumento + values?.apoderado?.cedulaRif : values?.apoderado?.tipoDocumento + values?.apoderado?.pasaporte,
                    font: list
                };
            }

            if (peopOnlist?.pep) {
                data.pep = {
                    full_name: values?.cliente?.nombre + " " + values?.cliente?.primerApellido + " " + values?.cliente?.segundoApellido,
                    document: values?.cliente?.tipoDocumento !== 'P' ? values?.cliente?.tipoDocumento + values?.cliente?.cedulaRif : values?.cliente?.tipoDocumento + values?.cliente?.pasaporte,
                    position_pep_id: values?.pep?.pregunta1?.nombreCargo,
                    font: list
                };
            }

            if (peopOnlist?.asociate) {
                data.asociadoPep = {
                    full_name: values?.cliente?.nombre + " " + values?.cliente?.primerApellido + " " + values?.cliente?.segundoApellido,
                    document: values?.cliente?.tipoDocumento !== 'P' ? values?.cliente?.tipoDocumento + values?.cliente?.cedulaRif : values?.cliente?.tipoDocumento + values?.cliente?.pasaporte,
                    asociate_info: values?.pep?.pregunta2,
                    font: 'pep2'
                };
            }

            const request = await ListsService.insertarClienteEnListaParaRevision(data);

            setInsertSpouseRepresentativePepForRevision(request?.data);
            setInsertSpouseRepresentativePepForRevisionIsLoading(false);
    
        } catch(error) {

            setInsertSpouseRepresentativePepForRevisionIsLoading(false);
            setInsertSpouseRepresentativePepForRevisionError(error.response?.data?.message || error.message);

        }
    }, []);

    return {
        insertSpouseRepresentativePepForRevisionIsLoading,
        insertSpouseRepresentativePepForRevisionError,
        insertSpouseRepresentativePepForRevision,
        handleInsertSpouseRepresentativePepForRevision,
    }
}
